// Chris Taylor Racing — interactions

(function () {
  const nav = document.getElementById('nav');
  const toggle = document.getElementById('navToggle');
  const links = document.getElementById('navLinks');

  // Sticky nav state
  const onScroll = () => nav.classList.toggle('is-scrolled', window.scrollY > 24);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  // Mobile menu
  toggle.addEventListener('click', () => {
    const open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
  });
  links.addEventListener('click', (e) => {
    if (e.target.tagName === 'A') {
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
  });

  // Scroll reveal
  const revealTargets = document.querySelectorAll(
    '.section__head, .card, .feature__copy, .pricecard, .build, .store__copy, .store__panel, .about__copy, .about__stats, .band__inner, .contact__copy, .contact__form'
  );
  revealTargets.forEach((el) => el.classList.add('reveal'));

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          entry.target.style.transitionDelay = (entry.target.classList.contains('card') || entry.target.classList.contains('build'))
            ? `${(i % 3) * 80}ms` : '0ms';
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealTargets.forEach((el) => io.observe(el));
  } else {
    revealTargets.forEach((el) => el.classList.add('is-in'));
  }

  // Active nav link for current page
  const page = (location.pathname.split('/').pop() || 'index.html').toLowerCase();
  document.querySelectorAll('.nav__links a').forEach((a) => {
    const href = (a.getAttribute('href') || '').toLowerCase();
    if (href === page || (page === '' && href === 'index.html')) a.classList.add('is-active');
  });

  // Year
  document.querySelectorAll('#year, .js-year').forEach((el) => {
    el.textContent = new Date().getFullYear();
  });
})();

// Demo contact form
function ctrSubmit(e) {
  e.preventDefault();
  const note = document.getElementById('formNote');
  if (note) note.hidden = false;
  e.target.querySelector('button[type="submit"]').textContent = 'Sent ✓';
  return false;
}
